import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { EntityCard } from '@xing-com/crate-x4e-entity-card';
import { Container } from '@xing-com/layout-primitives';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import {
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXS,
  spaceXXL,
} from '@xing-com/tokens';
import { Headline, BodyCopy, Meta } from '@xing-com/typography';

const ActionContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  gap: ${spaceXS};
  align-items: center;

  color: inherit;

  &:hover {
    text-decoration: none;
  }

  @media ${mediaConfined} {
    align-self: flex-end;
  }
`;

const ActionCopy = styled(BodyCopy)`
  padding: ${spaceM} 0 ${spaceM} 0;
  margin: 0;
`;

const EntityCardCustom = styled(EntityCard)`
  @media ${mediaSmallOrTiny} {
    max-width: 100%;
  }
`;

const Header = styled(Container)<{ $isDesktop: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${spaceXXL};
  }
`;

const HeadlineCustom = styled(Headline)`
  margin-bottom: ${spaceXS};
`;

const HiringButton = styled(Button)`
  margin-top: ${spaceXL};
`;

const Subline = styled(Meta)`
  margin-bottom: ${spaceS};
`;

export const Styled = {
  ActionContainer,
  ActionCopy,
  EntityCardCustom,
  Header,
  HeadlineCustom,
  HiringButton,
  Subline,
};
